var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53271 8.65941C3.54472 5.12559 6.41918 2.27059 9.95301 2.2826C13.4868 2.29461 16.3418 5.16907 16.3298 8.70289V8.77535C16.2863 11.0725 15.0037 13.1956 13.4313 14.8551C12.532 15.7889 11.5277 16.6157 10.4385 17.3188C10.1473 17.5708 9.71526 17.5708 9.42402 17.3188C7.80027 16.262 6.37516 14.9276 5.21387 13.3768C4.17884 12.0245 3.59119 10.3831 3.53271 8.68115L3.53271 8.65941Z",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.93134,
    cy: 8.7826,
    rx: 2.05072,
    ry: 2.05072,
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorCenter);
export default __webpack_public_path__ + "static/media/doctor-center.c97d18749d50c7f5b8cfb9c963e40c22.svg";
export { ForwardRef as ReactComponent };